import { render, staticRenderFns } from "./PresetSelectorDialog.vue?vue&type=template&id=3e06b5be&scoped=true"
import script from "./PresetSelectorDialog.vue?vue&type=script&lang=ts"
export * from "./PresetSelectorDialog.vue?vue&type=script&lang=ts"
import style0 from "./PresetSelectorDialog.vue?vue&type=style&index=0&id=3e06b5be&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e06b5be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e06b5be')) {
      api.createRecord('3e06b5be', component.options)
    } else {
      api.reload('3e06b5be', component.options)
    }
    module.hot.accept("./PresetSelectorDialog.vue?vue&type=template&id=3e06b5be&scoped=true", function () {
      api.rerender('3e06b5be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/PresetSelectorDialog.vue"
export default component.exports